import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals';

type MetricInput = { name: string; value: number };

function sendToAnalytics(metric: MetricInput) {
  if (import.meta.env.DEV) {
    console.log(`[Web Vitals] ${metric.name}: ${metric.value}`);
    return;
  }

  // Report to Sentry as a measurement (Sentry is loaded globally via main.tsx init)
  if (typeof window !== 'undefined' && (window as any).__sentryLoaded) {
    try {
      const Sentry = (window as any).Sentry;
      if (Sentry?.setMeasurement) {
        Sentry.setMeasurement(
          metric.name,
          metric.value,
          metric.name === 'CLS' ? '' : 'millisecond',
        );
      }
    } catch {
      // Sentry not available yet — ignore
    }
  }
}

export function reportWebVitals() {
  onCLS(sendToAnalytics);
  onFCP(sendToAnalytics);
  onLCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
  onINP(sendToAnalytics);
}
